import {
  activeSubscriptionPrices,
  isPriceEligibleForTrial,
} from "@circle-react/helpers/paywallPriceHelpers";
import type { Paywall, PaywallStatus } from "@circle-react/types/Paywall";
import { PAYWALL_STATUS } from "@circle-react/types/Paywall";
import type { PaywallPrice } from "@circle-react/types/PaywallPrice";
import { filter, some } from "lodash";

export const isActive = (paywall: Pick<Paywall, "status">): boolean =>
  paywall.status === PAYWALL_STATUS.ACTIVE;

export const isInactive = (paywall?: Pick<Paywall, "status">): boolean =>
  paywall?.status === PAYWALL_STATUS.INACTIVE;

const isPaywallEligibleForTrial = (paywall: Paywall): boolean =>
  some(paywall.stripe_prices_attributes, (paywallPrice: PaywallPrice) =>
    isPriceEligibleForTrial(paywallPrice),
  );

export const paywallsEligibleForTrial = (paywalls: Paywall[]): Paywall[] =>
  filter(paywalls, (paywall: Paywall) => isPaywallEligibleForTrial(paywall));

export const isEditingMode = (
  currentPaywallStatus: PaywallStatus | undefined,
): boolean => currentPaywallStatus !== undefined;

export const shouldDisplayWorkflowsTab = (
  currentPaywallStatus: PaywallStatus | undefined,
): boolean =>
  currentPaywallStatus === PAYWALL_STATUS.ACTIVE &&
  isEditingMode(currentPaywallStatus);

const hasActiveSubscriptionPrices = (paywall: Paywall): boolean =>
  activeSubscriptionPrices(paywall.stripe_prices_attributes || []).length > 0;

export const paywallsWithActiveSubscriptionPrices = (
  paywalls: Paywall[],
): Paywall[] =>
  filter(paywalls, (paywall: Paywall) => hasActiveSubscriptionPrices(paywall));

export const getPaywallAdminLabel = (
  paywall: Pick<Paywall, "display_name" | "name">,
): string => paywall.name || paywall.display_name;
